<script setup lang="ts"></script>
<template>
  <div
    class="grid grid-cols-3 gap-px md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6"
  >
    <slot></slot>
  </div>
</template>
